export const FeaturesList = {
  BetaToggle: 'beta_toggle',
  BlockCopyPaste: 'block_copy_paste',
  CreateSpaceTemplate: 'create_space_template',
  ExtendedCustomizer: 'extended_customizer',
  MobileBottomNavigation: 'mobile_bottom_navigation',
  PostTypes: 'post_types',
  Saml: 'saml',
  SearchPageTagFilter: 'search_page_tag_filter',
  SpaceCreationUsingTemplates: 'space_creation_using_templates',
  TotalsAnalytics: 'totals_analytics',
  TranslateButton: 'translate_button',
}
